import {
  PagedResponse,
  PatchWithMeta,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import { AnyAction } from "redux";
import { Attachment } from "../domain/Attachment";
import { SarsModel } from "../domain/SarsModel";
import { MODULE_NAME } from "../moduleName";
import { ShareRecord } from "../domain/ShareRecord";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const LOADED_ITEMS = `${MODULE_NAME}/LOADED_ITEMS`;
export const LOADING_ITEMS = `${MODULE_NAME}/LOADING_ITEMS`;

export const LOADED_ITEM = `${MODULE_NAME}/LOADED_ITEM`;
export const LOADING_ITEM = `${MODULE_NAME}/LOADING_ITEM`;
export const SAVED_ITEM = `${MODULE_NAME}/SAVED_ITEM`;

export const UPDATING_ITEM = `${MODULE_NAME}/UPDATING_ITEM`;
export const UPDATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/UPDATING_ITEM_VALIDATION_FAIL`;

export const INPUTTING_ITEM = `${MODULE_NAME}/INPUTTING_ITEM`;
export const CREATING_ITEM = `${MODULE_NAME}/CREATING_ITEM`;
export const CREATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/CREATING_ITEM_VALIDATION_FAIL`;
export const CREATED_ITEM = `${MODULE_NAME}/CREATED_ITEM`;
export const DELETE_ATTACHMENT = `${MODULE_NAME}/DELETE_ATTACHMENT`;

export const ATTACHING_EMAIL = `${MODULE_NAME}/ATTACHING_EMAIL`;

export const ASSIGNING_CASE = `${MODULE_NAME}/ASSIGNING_CASE`;
export const UNASSIGNING_CASE = `${MODULE_NAME}/UNASSIGNING_CASE`;

export const REOPEN_SAR = `${MODULE_NAME}/REOPEN_SAR`;
export const REJECT_SAR = `${MODULE_NAME}/REJECT_SAR`;

export const UPDATING_SHARE = `${MODULE_NAME}/UPDATING_SHARE`;
export const LOADED_SHARE = `${MODULE_NAME}/LOADED_SHARE`;

export const UNPAUSE_SAR = `${MODULE_NAME}/UNPAUSE_SAR`;
export const PAUSE_SAR = `${MODULE_NAME}/PAUSE_SAR`;

export const LOADING_FOI = `${MODULE_NAME}/LOADING_FOI`;
export const LOADED_FOI = `${MODULE_NAME}/LOADED_FOI`;
export const CREATING_FOI = `${MODULE_NAME}/CREATING_FOI`;

export const loadedItems = (payload: PagedResponse<SarsModel>) => ({
  type: LOADED_ITEMS,
  payload,
});
export const loadingItems = (payload: QueryParams) => ({
  type: LOADING_ITEMS,
  payload,
});

export const loadedItem = (item: SarsModel, share?: ShareRecord | null) => ({
  type: LOADED_ITEM,
  payload: { item, share },
});

export const savedItem = (item: SarsModel) => ({
  type: SAVED_ITEM,
  payload: item,
});

export const loadingItem = (id: string) => ({
  type: LOADING_ITEM,
  payload: id,
});

export const updatingItem = (
  id: string,
  patchWithMeta: PatchWithMeta<SarsModel>,
  newFiles: File[],
  attachmentsToDelete: Attachment[]
) => ({
  type: UPDATING_ITEM,
  payload: { id, patchWithMeta, newFiles, attachmentsToDelete },
});

export const createItem = (item: SarsModel) => ({
  type: CREATING_ITEM,
  payload: item,
});

export const inputtingItem = () => ({
  type: INPUTTING_ITEM,
});

export const deleteSelectedAttachment = (attachment: Attachment) => ({
  type: DELETE_ATTACHMENT,
  payload: {
    attachment,
  },
});

export const attachEmail = (id: string, file: File) => ({
  type: ATTACHING_EMAIL,
  payload: {
    id,
    file,
  },
});

export const assignCase = (
  id: string,
  assignedToUpn: string,
  assignedToDisplayName: string
) => ({
  type: ASSIGNING_CASE,
  payload: { id, assignedToUpn, assignedToDisplayName },
});

export const unassignCase = (id: string) => ({
  type: UNASSIGNING_CASE,
  payload: { id },
});

export const reopenSAR = (id: string) => ({
  type: REOPEN_SAR,
  payload: { id },
});

export const rejectSar = (id: string, response: string) => ({
  type: REJECT_SAR,
  payload: { id, response },
});

export const updatingShare = (id: string, share: ShareRecord) => ({
  type: UPDATING_SHARE,
  payload: { id, share },
});

export const loadedShare = (share: ShareRecord | null) => ({
  type: LOADED_SHARE,
  payload: share,
});

export const pauseSar = (id: string, reason: number, response: string) => ({
  type: PAUSE_SAR,
  payload: { id, reason, response },
});

export const unpauseSar = (id: string) => ({
  type: UNPAUSE_SAR,
  payload: { id },
});

export const loadingFoi = (id: string) => ({
  type: LOADING_FOI,
  payload: id,
});

export const loadedFoi = (foiResult: any) => ({
  type: LOADED_FOI,
  payload: foiResult,
});

export const createFoi = (id: string) =>({
  type: CREATING_FOI,
  payload: id,
})
